import { useNavigate } from "react-router";

export default function Travel() {
    const travelImages = [
        {img:"/images/dubai.jpeg", title:"Dubai - UAE"}, 
        {img: "/images/barcelona.png", title:"Barcelona - Spain"},
        {img:"/images/denver1.jpeg", title:"Colorado - US"},
        {img:"/images/montserra.png", title: "Montserrat - Spain"},
        {img:"/images/montreal.jpeg", title:"Montreal - Canada"},
        {img:"/images/drumheller.jpeg", title: "Drumheller - Canada"},
        {img:"/images/chicago.jpeg", title:"Chicago - US"},
        {img:"/images/abudhabi.jpeg", title:"Abu Dhabi - UAE"},

    ];
    const navigate = useNavigate()
    return (
        <div
            style={{
                padding: "20px",
                backgroundColor: "#f8f9fa",
                borderRadius: "10px",
                maxWidth: "900px",
                margin: "50px auto",
                boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
            }}
        >
            <h2
                style={{
                    textAlign: "center",
                    fontSize: "2rem",
                    fontWeight: "bold",
                    color: "#0d9f7d",
                    marginBottom: "20px",
                }}
            >
                My Love for Traveling
            </h2>
            <p
    style={{
        fontSize: "1.2rem",
        lineHeight: "1.6",
        color: "#333",
        textAlign: "justify",
    }}
>
    I truly enjoy traveling and exploring the world. I have been fortunate to visit several countries. Each trip has been a chance to 
    discover new places, and experience different cultures.
</p>
<p
    style={{
        fontSize: "1.2rem",
        lineHeight: "1.6",
        color: "#333",
        textAlign: "justify",
    }}
>
    I love connecting with people and learning from them. Traveling has not only been enjoyable but has also 
    helped me grow and appreciate the diversity of the world.
</p>

            {/* Travel Image Gallery */}
            <div
                style={{
                    marginTop: "30px",
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
                    gap: "15px",
                }}
            >
                {travelImages.map((image, index) => (
                    <div
                        key={index}
                        style={{
                            borderRadius: "10px",
                            overflow: "hidden",
                            boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
                        }}
                    >
                        <img
                            src={image.img}
                            alt={`Travel ${index + 1}`}
                            style={{ width: "100%", height: "300px", display: "block" }}
                        />
                        <p style={{textAlign:"center"}} className="mt-2">{image.title}</p>
                    </div>
                ))}
            </div>


            <div className="mt-3">
                <button
                    onClick={() => navigate("/Rayan/Home")} 
                    style={{
                        padding: "10px 20px",
                        backgroundColor: "#0d9f7d",
                        color: "white",
                        border: "none",
                        borderRadius: "5px",
                        cursor: "pointer",
                        fontSize: "1.1rem",
                        fontWeight: "bold",
                    }}
                >
                    Back to Home
                </button>
            </div>
        </div>
    );
}
